/* LittleMaddy cart: automatic free gifts + "complete your set" add-ons in the cart drawer. */
(function () {
  if (window.__lmCart) return; window.__lmCart = 1;
  var cfgEl = document.getElementById('lm-cart-config');
  if (!cfgEl) return;
  var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var gifts = C.gifts.filter(function (g) { return g.v; });
  var addons = C.addons.filter(function (a) { return a.id; });
  var lastCart = null, busy = false, again = false;

  function money(c) {
    var f = C.moneyFormat || '£{{amount}}';
    var a = (c / 100).toFixed(2);
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount\s*\}\}/, a).replace(/<[^>]+>/g, '');
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() { var d = drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; }
  function render(res, open) {
    var d = drawer(); if (!d || !res || !res.sections) return;
    if (open && d.renderContents) { d.classList.remove('is-empty'); d.renderContents(res); return; }
    d.getSectionsToRender().forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (el && res.sections[s.id]) el.innerHTML = d.getSectionInnerHTML(res.sections[s.id], s.selector);
    });
    if (typeof res.item_count === 'number') d.classList.toggle('is-empty', !res.item_count);
  }
  function braQty(cart) { return cart.items.reduce(function (n, i) { return n + (i.product_id === C.bra ? i.quantity : 0); }, 0); }
  function braSize(cart) {
    for (var i = 0; i < cart.items.length; i++) { var it = cart.items[i]; if (it.product_id === C.bra && it.options_with_values) { var o = it.options_with_values[C.braSizeIndex]; if (o) return o.value; } }
    return null;
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      lastCart = cart;
      var n = braQty(cart), updates = {}, change = false;
      gifts.forEach(function (g) {
        var want = n >= g.min ? 1 : 0;
        var have = cart.items.filter(function (i) { return i.variant_id === g.v; }).reduce(function (s, i) { return s + i.quantity; }, 0);
        if (want !== have) { updates[g.v] = want; change = true; }
      });
      if (!change) { busy = false; decorate(); if (again) { again = false; sync(); } return; }
      var body = { updates: updates, sections: sectionIds() };
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) { lastCart = res; render(res, false); busy = false; decorate(); if (again) { again = false; sync(); } });
    }).catch(function () { busy = false; });
  }

  function addonHtml(a, size) {
    var opts = a.options.map(function (o, k) {
      var def = o.n === 'Size' && size && o.v.indexOf(size) > -1 ? size : o.v[0];
      return '<label class="visually-hidden" for="lm-ao-' + a.id + '-' + k + '">' + esc(o.n) + '</label><select id="lm-ao-' + a.id + '-' + k + '" data-k="' + k + '">' + o.v.map(function (v) { return '<option' + (v === def ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join('') + '</select>';
    }).join('');
    var price = a.variants.length ? a.variants[0].p : 0;
    return '<div class="lm-ao" data-addon="' + a.id + '">' +
      (a.img ? '<img src="' + esc(a.img) + '" alt="" width="64" height="64" loading="lazy">' : '') +
      '<div class="lm-ao__body"><a class="lm-ao__title" href="' + esc(a.url) + '">' + esc(a.title) + '</a>' +
      (a.note ? '<span class="lm-ao__note">' + esc(a.note) + '</span>' : '') +
      '<div class="lm-ao__sel">' + opts + '</div></div>' +
      '<button type="button" class="lm-ao__add" data-lm-addon-add>+ ' + money(price) + '</button></div>';
  }
  function decorate() {
    var d = drawer(); if (!d || !lastCart) return;
    var host = d.querySelector('.drawer__inner'); if (!host) return;
    var old = host.querySelector('[data-lm-addons]');
    var inCart = lastCart.items.map(function (i) { return i.product_id; });
    var list = braQty(lastCart) > 0 ? addons.filter(function (a) { return inCart.indexOf(a.id) < 0; }) : [];
    if (!list.length) { if (old) old.remove(); return; }
    var key = list.map(function (a) { return a.id; }).join(',') + '|' + (braSize(lastCart) || '');
    if (old && old.getAttribute('data-key') === key) return;
    var box = document.createElement('div');
    box.className = 'lm-addons'; box.setAttribute('data-lm-addons', ''); box.setAttribute('data-key', key);
    box.innerHTML = '<p class="lm-addons__h">' + esc(C.heading || 'Complete your comfort set') + '</p>' + list.map(function (a) { return addonHtml(a, braSize(lastCart)); }).join('');
    if (old) old.replaceWith(box);
    else { var list2 = host.querySelector('cart-drawer-items'); if (list2) list2.appendChild(box); else { var footer = host.querySelector('.drawer__footer'); if (footer) footer.parentNode.insertBefore(box, footer); else host.appendChild(box); } }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lm-addon-add]'); if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-addon]'); var id = parseInt(row.getAttribute('data-addon'), 10);
    var a = addons.filter(function (x) { return x.id === id; })[0]; if (!a) return;
    var sel = [].map.call(row.querySelectorAll('select'), function (s) { return s.value; });
    var v = a.variants.filter(function (x) { return x.o.join('|') === sel.join('|'); })[0];
    if (!v || !v.a) { btn.textContent = 'Sold out'; return; }
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: sectionIds() }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { btn.disabled = false; btn.textContent = 'Try again'; return; }
        render(res, false); sync();
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  });

  var t; function soon() { clearTimeout(t); t = setTimeout(sync, 250); }
  function hook() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { subscribe(PUB_SUB_EVENTS.cartUpdate, soon); return true; }
    return false;
  }
  var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(decorate, 80); });
  function start() {
    if (!hook()) { var k = 0, iv = setInterval(function () { if (hook() || ++k > 40) clearInterval(iv); }, 250); }
    var d = drawer(); if (d) mo.observe(d, { childList: true, subtree: true });
    sync();
  }
  window.lmCartSync = soon;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* LittleMaddy: picking a size keeps the same photo, so don't jump the page back up to the gallery.
   Colour changes (a different photo) still scroll to the new photo as normal. */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('media-gallery').then(function () {
    var MG = customElements.get('media-gallery');
    if (!MG || MG.prototype.__lmPatched) return;
    var orig = MG.prototype.setActiveMedia;
    MG.prototype.__lmPatched = true;
    MG.prototype.setActiveMedia = function (mediaId) {
      var cur = this.querySelector('[data-media-id].is-active');
      if (cur && cur.dataset.mediaId === String(mediaId)) return;
      return orig.apply(this, arguments);
    };
  });
})();
